import React from 'react';
export const FooterSection = () => {
  return <footer className="bg-familia-bg border-t border-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-84">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-85">
        <div className="flex flex-col items-center text-center mb-8 md:mb-12" data-id="element-86">
          <div className="flex flex-wrap justify-center gap-4 text-sm text-familia-gray mb-8" data-id="element-87">
            <span data-id="element-88">✅ 5 módulos + Módulo VIP + 3 bonos</span>
            <span data-id="element-89">✅ +240 páginas de contenido práctico</span>
            <span data-id="element-90">✅ Acceso inmediato por email</span>
            <span data-id="element-91">✅ Garantía de satisfacción de 30 días</span>
          </div>
          <div className="flex flex-col mb-4" data-id="element-92">
            <span className="text-familia-cyan font-display text-2xl sm:text-3xl font-bold leading-tight" data-id="element-93">
              📚 VITALIDAD 360™
            </span>
            <span className="text-familia-gray text-xs sm:text-sm font-semibold tracking-widest uppercase mt-1" data-id="element-94">
              Master Kit Adultos Mayores
            </span>
          </div>
        </div>
        <div className="w-full h-px bg-familia-cyan/15 mb-12" data-id="element-95" />
        <div className="max-w-4xl mx-auto space-y-6 text-center text-[10px] sm:text-xs text-familia-gray leading-relaxed" data-id="element-96">
          <p data-id="element-97">
            © VITALIDAD 360™ 2026 — Todos los derechos reservados. Prohibida
            la reproducción sin autorización expresa.
          </p>
          <p data-id="element-98">
            VITALIDAD 360™ es un producto digital educativo para familias,
            cuidadores y profesionales que acompañan adultos mayores. No brinda
            diagnóstico ni tratamiento médico y no reemplaza la consulta con
            profesionales de la salud. Antes de iniciar rutinas de ejercicio,
            alimentación o cuidado, se recomienda consultar con un profesional,
            especialmente si el adulto mayor tiene condiciones médicas,
            movilidad reducida o antecedentes de caídas. Los resultados pueden
            variar según cada persona, su constancia y acompañamiento.
          </p>
        </div>
      </div>
    </footer>;
};